import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {nonBlank} from "../utils/epic.utils";

@Component({
  selector: 'acc-action-bar',
  imports: [],
  templateUrl: './action-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-bar.component.css'
})
export class ActionBarComponent {

  @Input()
  public justifyContent: 'end' | 'start' | 'center' = 'start';

  /**
   * @deprecated use accClass instead
   */
  @Input()
  public class: string = '';

  @Input()
  public accClass: string = '';

  protected getClass(): string {
    let clazz = nonBlank(this.accClass) ? this.accClass : this.class;
    clazz += ' ' + this.getJustifyContent();
    return clazz;
  }

  private getJustifyContent(): string {
    return 'justify-content-' + this.justifyContent;
  }
}
